import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketFinancePaymentSelectionAC } from './AC/BasketFinancePaymentSelection.AC';
import { BasketFinancePaymentSelectionOV } from './OV/BasketFinancePaymentSelection.OV';
import { BasketFinancePaymentSelectionAP } from './AP/BasketFinancePaymentSelection.AP';
import { BasketFinancePaymentSelectionDS } from './DS/BasketFinancePaymentSelection.DS';
import { BasketFinancePaymentSelectionOV as BasketCashPaymentSelectionOV_GB } from './OV/GB/BasketFinancePaymentSelection.OV';
import { BasketSelectSectionStyled } from './BasketFinancePaymentSelectionStyled';
import { SC } from '../../../styles/theme';

export type BasketFinancePaymentSelectionProps = SC & {
    onClick: (value: string) => void;
    isSelected: boolean;
    handleFinanceWidgetBtnClick: () => void;
};

const BasketFinancePaymentSelection = (props: BasketFinancePaymentSelectionProps) => {
    if (BRAND === 'AC') return <BasketFinancePaymentSelectionAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <BasketCashPaymentSelectionOV_GB {...props} />
        ) : (
            <BasketFinancePaymentSelectionOV {...props} />
        );
    if (BRAND === 'AP') return <BasketFinancePaymentSelectionAP {...props} />;
    if (BRAND === 'DS') return <BasketFinancePaymentSelectionDS {...props} />;
    return <BasketSelectSectionStyled {...props} />;
};

export default BasketFinancePaymentSelection;
